import React from 'react';

interface TreeConnectorProps {
  type: 'root-to-children' | 'branch-connector' | 'branch-to-children';
  height?: string; // Dynamic height for vertical connectors
}

const TreeConnector: React.FC<TreeConnectorProps> = ({ type, height }) => {
  switch (type) {
    case 'root-to-children':
      // Remove red vertical lines - return null
      return null;
    
    case 'branch-connector':
      return (
        <div className="mobile-connector branch-connector" aria-hidden="true">
          <div className="mobile-connector-dot" aria-hidden="true"></div>
        </div>
      );
    
    case 'branch-to-children':
      // Remove blue vertical lines - return null
      return null;
    
    default:
      return null;
  }
};

export default TreeConnector;
